import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";

function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it) return (it = it.call(o)).next.bind(it);

  if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it) o = it;
    var i = 0;
    return function () {
      if (i >= o.length) return {
        done: true
      };
      return {
        done: false,
        value: o[i++]
      };
    };
  }

  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

import React, { useState, useEffect } from 'react';
import '../../primitives/Box/Box.es.js';
import '../../primitives/Center/styled.es.js';
import '../../primitives/Group/Group.es.js';
import '../../primitives/Grid/Grid.es.js';
import '../../primitives/Level/Level.es.js';
import '../../primitives/Shelf/Shelf.es.js';
import '../../primitives/Portal/Portal.es.js';
import '../../primitives/Hidden/Hidden.es.js';
import '../../primitives/Media/Media.es.js';
import '../../primitives/Dialog/Dialog.es.js';
import { ConditionalWrapper } from '../../primitives/ConditionalWrapper/ConditionalWrapper.es.js';
import '../../primitives/VisuallyHidden/VisuallyHidden.es.js';
import '../../primitives/TruncateByCharacters/TruncateByCharacters.es.js';
import '../../primitives/TruncateByLines/TruncateByLines.es.js';
import 'react-transition-group';
import '../../primitives/Popper/Popper.es.js';
import '../../primitives/DragHandle/DragHandle.es.js';
import { Pin } from '../../primitives/Pin/Pin.es.js';
import { Dot, Badge as Badge$1, Content } from './styled.es.js';
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;

var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};

var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }

  if (__getOwnPropSymbols) {
    for (var _iterator = _createForOfIteratorHelperLoose(__getOwnPropSymbols(b)), _step; !(_step = _iterator()).done;) {
      var prop = _step.value;
      if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    }
  }

  return a;
};

var __objRest = function __objRest(source, exclude) {
  var target = {};

  for (var prop in source) {
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  }

  if (source != null && __getOwnPropSymbols) {
    for (var _iterator2 = _createForOfIteratorHelperLoose(__getOwnPropSymbols(source)), _step2; !(_step2 = _iterator2()).done;) {
      var prop = _step2.value;
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
  }

  return target;
};

var BadgeElement = function BadgeElement(_a) {
  var _b = _a,
      contentProp = _b.content,
      _b$max = _b.max,
      max = _b$max === void 0 ? 99 : _b$max,
      IconComponent = _b.icon,
      _b$variant = _b.variant,
      variant = _b$variant === void 0 ? "default" : _b$variant,
      _b$size = _b.size,
      size = _b$size === void 0 ? "md" : _b$size,
      _b$isRounded = _b.isRounded,
      isRounded = _b$isRounded === void 0 ? false : _b$isRounded,
      _b$kind = _b.kind,
      kind = _b$kind === void 0 ? "base" : _b$kind,
      _b$showZero = _b.showZero,
      showZero = _b$showZero === void 0 ? false : _b$showZero,
      _b$isDot = _b.isDot,
      isDot = _b$isDot === void 0 ? false : _b$isDot,
      _b$isPinned = _b.isPinned,
      isPinned = _b$isPinned === void 0 ? false : _b$isPinned,
      props = __objRest(_b, ["content", "max", "icon", "variant", "size", "isRounded", "kind", "showZero", "isDot", "isPinned"]);

  var _useState = useState(contentProp),
      content = _useState[0],
      setContent = _useState[1];

  useEffect(function () {
    switch (typeof contentProp) {
      case "number":
        setContent(contentProp > max ? max + "+" : contentProp);
        break;

      default:
        setContent(contentProp);
        break;
    }
  }, [contentProp, max]);

  if (!showZero && typeof content === "number" && content <= 0) {
    return (
      /* @__PURE__ */
      React.createElement(React.Fragment, null)
    );
  }

  if (contentProp === "undefined" && !IconComponent || isDot) {
    return (
      /* @__PURE__ */
      React.createElement(Dot, {
        variant: variant,
        kind: kind,
        isPinned: isPinned
      })
    );
  }

  return (
    /* @__PURE__ */
    React.createElement(Badge$1, __spreadValues({
      variant: variant,
      size: size,
      kind: kind,
      isRounded: isRounded,
      isPinned: isPinned
    }, props),
    /* @__PURE__ */
    React.createElement(ConditionalWrapper, {
      condition: content,
      wrapper: function wrapper(children) {
        return (
          /* @__PURE__ */
          React.createElement(Content, {
            size: size
          }, children)
        );
      }
    }, !!IconComponent &&
    /* @__PURE__ */
    React.createElement(IconComponent, {
      size: "xs"
    }), content))
  );
};

var PinnedBadge = function PinnedBadge(_c) {
  var _d = _c,
      children = _d.children,
      _d$anchorShape = _d.anchorShape,
      anchorShape = _d$anchorShape === void 0 ? "square" : _d$anchorShape,
      _d$pinPlacement = _d.pinPlacement,
      pinPlacement = _d$pinPlacement === void 0 ? "top-right" : _d$pinPlacement,
      props = __objRest(_d, ["children", "anchorShape", "pinPlacement"]);

  var offset = {
    square: [0, 0],
    circle: ["14%", "14%"]
  };
  return (
    /* @__PURE__ */
    React.createElement(Pin, {
      pinOffset: offset[anchorShape],
      component:
      /* @__PURE__ */
      React.createElement(BadgeElement, __spreadValues({
        isPinned: true
      }, props)),
      placement: pinPlacement
    }, children)
  );
};

var Badge = function Badge(_e) {
  var _f = _e,
      children = _f.children,
      props = __objRest(_f, ["children"]);

  return children ?
  /* @__PURE__ */
  React.createElement(PinnedBadge, __spreadValues({}, props), children) :
  /* @__PURE__ */
  React.createElement(BadgeElement, __spreadValues({}, props));
};

export { Badge };